import Box from '@mui/material/Box';
import React from 'react';
import { ImageLoader } from 'components';
// eslint-disable-next-line
import LazyLoad from 'react-lazy-load';

export default function TitleImage() {
  return (
    <Box display='flex' justifyContent='center'>
      <a href='/'>
        <LazyLoad height={'30px'} className='titleContainer'>
          <ImageLoader
            className='titleImage'
            loadedClassName='titleImageLoaded'
            src='/images/logo.png'
            alt='Logo'
            width='80'
            height='30'
          />
        </LazyLoad>
      </a>
    </Box>
  );
}
